import { ButtonBase, Typography } from '@mui/material'
import { ChevronDown20Regular } from '@/components/Icon'
import prefStyles from '@/components/Settings/SettingsPreferenceSection.module.scss'

/**
 * @param {{ ariaLabel: string, listId: string, open: boolean, selectedLabel: string, onOpen: (el: HTMLElement) => void }} props
 */
export function PreferenceFloatingSelectTrigger({ ariaLabel, listId, open, selectedLabel, onOpen }) {
  return (
    <ButtonBase
      type="button"
      aria-haspopup="listbox"
      aria-expanded={open}
      aria-controls={open ? listId : undefined}
      aria-label={ariaLabel}
      onClick={(e) => onOpen(e.currentTarget)}
      className={prefStyles.floatingSelect}
    >
      <Typography component="span" variant="body2" className={prefStyles.floatingSelectLabel}>
        {selectedLabel}
      </Typography>
      <span className={`${prefStyles.chevron}${open ? ` ${prefStyles.chevronOpen}` : ''}`}>
        <ChevronDown20Regular aria-hidden />
      </span>
    </ButtonBase>
  )
}
